// extracted by css-extract-rspack-plugin
export default {"container":"CheckBox-module__container","checked":"CheckBox-module__checked","disabled":"CheckBox-module__disabled","ripple":"CheckBox-module__ripple"};